import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { Avatar, Badge, makeStyles, Text, tokens } from '@fluentui/react-components'
import { FilePartyRoleDto } from '../../../../context/GlobalContext'
import { MainDto } from '../../../../config/filePartyConfig'
import { IFileDto } from '../../../../config/fileConfig'
import FilePartyCard from './FilePartyCard'

const useStyles = makeStyles({
    section: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalS,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        columnGap: tokens.spacingHorizontalS,
        paddingLeft: tokens.spacingHorizontalS,
        paddingTop: tokens.spacingVerticalS,
    },
    label: { fontWeight: tokens.fontWeightSemibold },
})

export type FilePartySectionProps = {
    role: FilePartyRoleDto
    parties: MainDto[]
    file: IFileDto
    roles: FilePartyRoleDto[]
    reset?: () => void
}

/**
 * One partijsoort (role): a header with the label and party count, followed by one card per bedrijf. Renders
 * nothing when the soort has no parties, so empty sections never take up space.
 */
export default function FilePartySection(props: FilePartySectionProps): ReactElement {
    const styles = useStyles()

    const sortedParties = useMemo(() => [...props.parties].sort((a, b) => (a.displayName || '').localeCompare(b.displayName || '')), [props.parties])

    if (sortedParties.length === 0) {
        return null
    }

    return (
        <section className={styles.section}>
            <div className={styles.header}>
                <Avatar color="colorful" name={props.role.label} idForColor={props.role.label} size={20} />
                <Text className={styles.label}>{props.role.label}</Text>
                <Badge appearance="tint" color="informative">
                    {sortedParties.length}
                </Badge>
            </div>
            {sortedParties.map(party => (
                <FilePartyCard
                    key={party.pivotId}
                    party={party}
                    file={props.file}
                    roles={props.roles}
                    roleName={props.role.label}
                    reset={props.reset}
                />
            ))}
        </section>
    )
}
